import React, { useState, useEffect } from "react";
import Icon from "../assets/icons";
import { formatDate } from "../utilities/functions";
import { capitalizeFirstLetter } from "../utilities/functions";

interface TableColumn {
  header: string;
  accessor: string;
}

interface TableRow {
  [key: string]: any;
}

interface TableProps {
  columns: TableColumn[];
  data: TableRow[];
  selectedUserId: string | null;
  currentPage?: number | null;
  onPageChange?: number | null;
  onUserClick: (id: string) => void;
  onDeleteAdmin?: (id: string) => void;
  onToggleSuspension?: (id: string) => void;
  setIsSuspended?: (val: boolean) => void;
}

const TableAdmin: React.FC<TableProps> = ({
  columns,
  data,
  onUserClick,
  selectedUserId,
  onDeleteAdmin,
  onToggleSuspension,
  setIsSuspended,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState<string | null>(null);

  const isOwner =
    JSON.parse(localStorage.getItem("user") as string)?.role?.name === "owner";

  useEffect(() => {
    const handleClickOutside = () => {
      // Close dropdown when clicking outside
      setDropdownOpen(null);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = (id: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setDropdownOpen(dropdownOpen === id ? null : id);
  };

  const handleViewClick = (id: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onUserClick(id);
    setDropdownOpen(null);
  };
  const handleSuspensionToggle = (id: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (onToggleSuspension) {
      onToggleSuspension(id);
    }
  };

  const handleDeleteClick = (id: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (onDeleteAdmin) {
      onDeleteAdmin(id);
    }
    setDropdownOpen(null);
  };

  return (
    <table className=" mt-6 w-full">
      <thead className="bg-[#CFF0FC] h-10">
        <tr className="text-[16px] text-left">
          {columns.map((column, index) => (
            <th className="font-medium" key={index}>
              {column.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="text-[12px]">
        {data.map((row, rowIndex) => (
          <tr key={rowIndex} className="cursor-pointer">
            {columns.map((column, colIndex) => (
              <td
                key={colIndex}
                className="pt-5"
                onClick={
                  column.accessor === "id"
                    ? undefined
                    : () => onUserClick(row.id)
                }
              >
                {column.accessor === "created_at" ||
                column.accessor === "createdAt" ? (
                  formatDate(row[column.accessor])
                ) : column.header === "" ? (
                  <img
                    src={`https://ui-avatars.com/api/?name=${
                      row[column.accessor]
                    }&background=0979A1&color=fff`}
                    className="rounded-full w-[40px] h-[40px]"
                    alt="profile"
                  />
                ) : column.accessor === "id" ? (
                  <div className="relative">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleDropdown(row["id"], e);
                      }}
                      className="p-2 hover:bg-gray-100 rounded focus:outline-none cursor-pointer"
                    >
                      <Icon name="dotIcon" />
                    </button>
                    {dropdownOpen === row["id"] && (
                      <div
                        className="absolute right-0 mt-1 w-[180px] bg-white border border-gray-200 rounded-md shadow-lg z-50 overflow-hidden"
                        onMouseDown={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <div
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleViewClick(row["id"], e);
                          }}
                          className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                        >
                          View profile
                        </div>
                        {isOwner && (
                          <div
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (row.suspendedBy && setIsSuspended) {
                                setIsSuspended(true);
                              }
                              handleSuspensionToggle(row["id"], e);
                            }}
                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                          >
                            {row.suspendedBy ? "Unsuspend" : "Suspend"} admin
                          </div>
                        )}

                        {onDeleteAdmin && (
                          <div
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleDeleteClick(row["id"], e);
                            }}
                            className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer"
                          >
                            Delete
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : column.header === "Name" ? (
                  capitalizeFirstLetter(row[column.accessor])
                ) : column.accessor === "_id" ? (
                  <button onClick={() => onUserClick(row["_id"])}>
                    <Icon name="dotIcon" />
                  </button>
                ) : column.accessor === "phone" && !row[column.accessor] ? (
                  "N/A"
                ) : column.accessor === "role" ? (
                  capitalizeFirstLetter(row[column.accessor]?.name)
                ) : (
                  row[column.accessor]
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableAdmin;
